export const LegalDocumentPrivacySetting = {
  Private: 1,
  SHARED_WITH_PARTNERS: 2,
};

export const LegalDocumentPrivacySettingList = [
  { id: LegalDocumentPrivacySetting.Private, name: "Private" },
  { id: LegalDocumentPrivacySetting.SHARED_WITH_PARTNERS, name: "Shared With Partners" },
];
